/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum WcSupportHappierWithType {
  PhysicalHealth = 'PhysicalHealth',
  Family = 'Family',
  Work = 'Work',
  Financial = 'Financial',
  MentalHealth = 'MentalHealth',
  Relationships = 'Relationships',
  Other = 'Other',
  SomethingElse = 'SomethingElse'
}
